// extracted by mini-css-extract-plugin
export default {"loaderContainer":"loader_loaderContainer__8qSlb","spinner":"loader_spinner__PwOFp","spin":"loader_spin__hHc+F"};